/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Status_StartingInputs */



/**
* | output |
* | --- |
* | "Starting transcription..." |
*
* @param {Offline_Sync_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_status_starting = /** @type {((inputs?: Offline_Sync_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrage de la transcription...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkription wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio trascrizione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запуск транскрибации...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando transcripción...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在开始转写...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文字起こしを開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रांसक्रिप्शन शुरू हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A iniciar transcrição...")
	return /** @type {LocalizedString} */ ("Starting transcription...")
});